import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import { ALL_TAG_NAME } from '@/components/InspirationCenter/inspiration-center.const.js';
import InspirationCenterService from '@/components/InspirationCenter/inspiration-center-service.js';

const buildInspirationCenterGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const useIdea = buildInspirationCenterGetterObject('useIdea');
export const useInspirationTags = buildInspirationCenterGetterObject('useInspirationTags');
export const useInspirationIdeas = buildInspirationCenterGetterObject('useInspirationIdeas');
export const useMyTeamsIdeas = buildInspirationCenterGetterObject('useMyTeamsIdeas');
export const useCommentsOfIdea = buildInspirationCenterGetterObject('useCommentsOfIdea');
export const useCommentsIdsOfIdea = buildInspirationCenterGetterObject('useCommentsIdsOfIdea');
export const useComment = buildInspirationCenterGetterObject('useComment');
export const useComments = buildInspirationCenterGetterObject('useComments');
export const useCommentsOfIdeaHashed = buildInspirationCenterGetterObject('useCommentsOfIdeaHashed');
export const useFocusOnIdea = buildInspirationCenterGetterObject('useFocusOnIdea');
export const useNumOfCommentsOfIdea = buildInspirationCenterGetterObject('useNumOfCommentsOfIdea');

const getters = {
	[useInspirationTags.getter]: (state) => [ALL_TAG_NAME, ...state.tags],
	[useInspirationIdeas.getter]: (state) => state.ideas,
	[useMyTeamsIdeas.getter]: (state, getters) =>
		Object.values(getters[useInspirationIdeas.getter]).filter(InspirationCenterService.isIdeaSavedToAccount),
	[useIdea.getter]: (state, getters) => (ideaId) => getters[useInspirationIdeas.getter][ideaId],
	[useComments.getter]: (state) => state.comments,
	[useComment.getter]: (state, getters) => (commentId) => getters[useComments.getter][commentId],
	[useCommentsIdsOfIdea.getter]: (state) => (ideaId) =>
		Object.entries(state.comments)
			.filter(([, comment]) => comment.idea === ideaId)
			.map(([id]) => id),
	[useCommentsOfIdea.getter]: (state, getters) => (ideaId) =>
		getters[useCommentsIdsOfIdea.getter](ideaId).map((commentId) => getters[useComment.getter](commentId)),
	[useCommentsOfIdeaHashed.getter]: (state, getters) => (ideaId) =>
		Object.fromEntries(getters[useCommentsOfIdea.getter](ideaId).map((comment) => [comment.id, comment])),
	[useFocusOnIdea.getter]: (state) => state.focusOnIdea,
	[useNumOfCommentsOfIdea.getter]: (state, getters) => (ideaId) => getters[useIdea.getter](ideaId).account_idea.comments_count,
};

export default getters;
